import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'shared/hooks';
import { setAllFiltersModalOpen } from 'shared/slices/modal';
import { setSearchMetaTooltipAvailable } from 'shared/slices/searchMetaTooltip';
import { AllFiltersModalContainer } from './containers';
import { selectAllFiltersModalOpened } from 'shared/selectors/modals';

export const AllFiltersContainer: FC = () => {
  const dispatch = useAppDispatch();
  const opened = useSelector(selectAllFiltersModalOpened);

  const onClose = useCallback(() => {
    dispatch(setAllFiltersModalOpen(false));
    dispatch(setSearchMetaTooltipAvailable(true));
  }, [dispatch]);

  if (!opened) {
    return null;
  }

  return <AllFiltersModalContainer onClose={onClose} />;
};
